import React from 'react';
import { Typo } from '@ers/ui/';
import { sendAdvicesClickedEvent, sendCreatorClickedEvent, sendEarningsClickedEvent, sendPracujClickedEvent, sendTheProtocolClickedEvent } from '@ers/root/App.actions';
import MenuItemTypes from './MenuItemTypes';
import LogoutMenuItem from './LogoutMenuItem';
import MessagesMenuItem from './MessagesMenuItem';
import Menus from './Menus';
import URL from './Urls';
import { Separator } from '../ui';

export { MenuItemTypes };

export class MenuItem {
    constructor({
        type,
        url = () => '',
        name,
        onClick = () => null,
        icon = null,
        simpleLayout = false,
        pattern,
        regex = null,
        nameRender,
        place = Menus.Main,
        prefix = null
    }) {
        this.type = type;
        this.url = url;
        this.name = name;
        this.onClick = onClick;
        this.icon = icon;
        this.pattern = pattern;
        this.simpleLayout = simpleLayout;
        this.regex = regex;
        this.nameRender = nameRender || (() => <Typo.Menu>{this.name}</Typo.Menu>);
        this.place = place;
        this.prefix = prefix;
    }

    static get = (type, place) => (place ? MenuItems.find((m) => m.place === place && m.type === type) : MenuItems.find((m) => m.type === type));
}


export const MenuItems = [
    new MenuItem({
        type: MenuItemTypes.Home,
        name: 'Moje aplikacje',
        icon: 'form',
        url: () => '/',
        pattern: '/',
        regex: /^(\/|\/ConfirmApplication.*|\/DenyApplication.*|\/application\/{0,1}\d*)$/
    }),
    new MenuItem({
        type: MenuItemTypes.Archive,
        name: 'Aplikacje archiwalne',
        icon: 'archive',
        url: () => '/archive',
        pattern: '/archive',
        regex: /^\/archive|\/application\/\d+\/archive{0,1}$/,
    }),
    new MenuItem({
        type: MenuItemTypes.Form,
        url: () => '/application',
        pattern: '/application',
        regex: /^\/application\/\d+\/archive{0,1}$/,
    }),
    new MenuItem({
        type: MenuItemTypes.Messages,
        name: 'Wiadomości',
        icon: 'envelope',
        url: () => '/messages',
        pattern: '/messages',
        regex: /^\/messages\/{0,1}\d*$/,
        nameRender: (name) => (
            <MessagesMenuItem name={name} />
        )
    }),
    new MenuItem({
        type: MenuItemTypes.Advices,
        name: 'Porady',
        icon: 'book',
        url: () => URL.PRACUJ.ADVICES,
        onClick: (dispatch) => dispatch(sendAdvicesClickedEvent()),
        prefix: () => <Separator className="separator--menu" />
    }),
    new MenuItem({
        type: MenuItemTypes.Creator,
        name: 'Kreator CV',
        icon: 'creator',
        url: () => URL.PRACUJ.CREATOR,
        onClick: (dispatch) => dispatch(sendCreatorClickedEvent())
    }),
    new MenuItem({
        type: MenuItemTypes.Earnings,
        name: 'Zarobki',
        icon: 'money',
        url: () => URL.PRACUJ.EARNINGS,
        onClick: (dispatch) => dispatch(sendEarningsClickedEvent())
    }),
    new MenuItem({
        type: MenuItemTypes.Pracuj,
        name: 'Pracuj.pl',
        icon: 'case',
        url: () => URL.PRACUJ.MAIN,
        onClick: (dispatch) => dispatch(sendPracujClickedEvent()),
        prefix: () => <Separator className="separator--menu" />
    }),
    new MenuItem({
        type: MenuItemTypes.TheProtocol,
        name: 'the:protocol',
        icon: 'devices',
        url: () => URL.THEPROTOCOL,
        onClick: (dispatch) => dispatch(sendTheProtocolClickedEvent()),
    }),
    new MenuItem({
        type: MenuItemTypes.Settings,
        name: 'Ustawienia',
        icon: 'rack',
        url: () => '/settings',
        pattern: '/settings',
        regex: /^\/settings$/,
        nameRender: (name) => <Typo.Body>{name}</Typo.Body>,
        place: Menus.UserBox
    }),
    new MenuItem({
        type: MenuItemTypes.DenyApplication,
        url: () => `/DenyApplication `,
        pattern: '/DenyApplication',
        regex: /^\/DenyApplication$/
    }),
    new MenuItem({
        type: MenuItemTypes.ConfirmApplication,
        url: () => `/ConfirmApplication `,
        pattern: '/ConfirmApplication',
        regex: /^\/ConfirmApplication$/
    }),
    new MenuItem({
        type: MenuItemTypes.PageNotFound,
        url: () => `/404`,
        pattern: '/404',
        regex: /^\/404$/,
        simpleLayout: true
    }),
    new MenuItem({
        type: MenuItemTypes.ServerError,
        url: () => `/500`,
        pattern: '/500',
        regex: /^\/500$/,
        simpleLayout: true
    }),
    new MenuItem({
        type: MenuItemTypes.AuthErrorPage,
        url: () => `/401`,
        pattern: '/401',
        regex: /^\/401$/,
        simpleLayout: true
    }),
    new MenuItem({
        type: MenuItemTypes.NotAllowed,
        url: () => `/403`,
        pattern: '/403',
        regex: /^\/403$/,
        simpleLayout: true
    }),
    // { type: Types.Form, url: (applicationId) => `/form/${applicationId}`, pattern: '/form/:applicationId' },
    new MenuItem(LogoutMenuItem)
];
